import { useEffect, useState } from "react";
import { Button, ButtonProps, Spinner } from "react-bootstrap";

import messages from "messages";
import queryStripeConnectAccountUrl from "services/queryStripeConnectAccountUrl";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";
import { AmplitudePageName, track } from "utils/amplitude";

const StripeSetupButton = ({
  children,
  className,
  amplitudePageName,
  amplitudeComponentName,
  ...props
}: ButtonProps & {
  amplitudePageName: AmplitudePageName;
  amplitudeComponentName?: string;
}) => {
  const [busy, setBusy] = useState(false);

  const [url, setUrl] = useState("");

  useEffect(() => {
    window.localStorage.setItem(
      "redirect_after_stripe_connect",
      window.location.pathname + window.location.search + window.location.hash,
    );
    console.log(window.localStorage.getItem("redirect_after_stripe_connect"));

    // get url on init
    setBusy(true);
    queryStripeConnectAccountUrl()
      .then(({ url }) => setUrl(url))
      // should catch error
      .catch(console.error)
      .finally(() => setBusy(false));
  }, []);

  return (
    <>
      {busy && !url ? (
        <Button variant="link" size="sm" disabled>
          <Spinner
            as="span"
            animation="grow"
            size="sm"
            role="status"
            aria-hidden="true"
          />
          {messages.loading}
        </Button>
      ) : (
        <Button
          size="sm"
          as="a"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          {...props}
          className={getClasses(className, styles["stripe-setup-button__btn"])}
          onClick={() =>
            track(
              amplitudePageName,
              amplitudeComponentName
                ? [amplitudeComponentName, "setup-payment-method-button"]
                : ["setup-payment-method-button"],
              "click",
            )
          }
        >
          {children || messages.setupPaymentMethod}
        </Button>
      )}
    </>
  );
};

export default StripeSetupButton;
